module.exports = {
      id: "icon-timer-usage",
      viewBox: "0 0 15.177 16",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-timer",
      toString: function () {
        return this.url;
      }
    }